import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const FuseRatingCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-fuse-rating-calculator" />;

export default FuseRatingCalculatorGuidePage;
